import React from "react";
import { string } from "prop-types";

const EnglishHeaderLogo = ({ width = "116", height = "38" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 230 78" width={width} height={height}>
    <g>
      <g>
        <path
          fill="#ED4523"
          d="M141.297,29.36c5.953,0,10.775-4.826,10.775-10.771c0-5.952-4.822-10.777-10.775-10.777
			c-5.945,0-10.772,4.825-10.772,10.777C130.524,24.534,135.351,29.36,141.297,29.36z"
        />
        <g>
          <rect
            x="140.749"
            y="1.017"
            transform="matrix(1 -0.0012 0.0012 1 -0.0045 0.1763)"
            fill="#ED4523"
            width="1.097"
            height="5.361"
          />
        </g>
        <g>
          <rect
            x="146.065"
            y="5.109"
            transform="matrix(0.4852 -0.8744 0.8744 0.4852 71.6346 132.9908)"
            fill="#ED4523"
            width="5.395"
            height="1.097"
          />
        </g>
        <g>
          <rect
            x="151.286"
            y="10.511"
            transform="matrix(0.8519 -0.5238 0.5238 0.8519 17.0157 82.2803)"
            fill="#ED4523"
            width="5.36"
            height="1.098"
          />
        </g>
        <g>
          <rect
            x="133.442"
            y="2.922"
            transform="matrix(0.873 -0.4878 0.4878 0.873 14.2927 66.0692)"
            fill="#ED4523"
            width="1.097"
            height="5.345"
          />
        </g>
        <g>
          <rect
            x="128.235"
            y="8.302"
            transform="matrix(0.5117 -0.8592 0.8592 0.5117 53.4711 116.0037)"
            fill="#ED4523"
            width="1.098"
            height="5.322"
          />
        </g>
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#221F1F"
            d="M96.613,21.229c-8.733,5.636-12.003,7.246-12.003,7.246v5.533c11.186-5.301,18.045,1.46,18.045,1.46v1.895
				h5.238c0,0,0-14.027,0-16.074c0-2.049-1.7-2.79-1.7-2.79h9.388c0,0-2.848,0.818-4.073,1.642
				c-1.434,0.962-1.133,2.528-1.133,2.528l6.402,2.66c0,0,0.782,0.23,0.811,0.795c0.047,0.67-0.815,0.879-0.815,0.879
				s-3.688,0.286-5.531,1.796c-1.327,1.093-1.019,2.038-1.019,2.038v2.749c0.002,0.234,0.002,0.424,0.122,0.543
				c1.462,1.514,4.254,1.977,4.254,1.977l2.26-1.234c-2.385-0.182-2.489-0.729-2.524-1.192c-0.019-0.371,0.369-1.566,5.363-1.822
				c4.472-0.228,8.869,2.98,8.869,2.98v2.508h5.23c0,0,0-15.227,0-15.947c0-0.922-0.254-4.624-4.939-4.624l-4.562-0.032H99.318
				v0.731c3.401,0.344,3.335,2.65,3.335,2.65v11.239c-3.701-3.227-8.552-3.42-8.552-3.42c2.615-1.431,4.516-3.078,5.551-3.944
				c0.345-0.294,0.825-1.047,0.293-2.185c-0.822-1.758-1.78-3.106-3.293-4.456c-2.229-1.988-5.095-0.695-5.095-0.695l-2.782,1.255
				c-7.137-4.002-11.376-0.285-11.376-0.285v0.821c-11.042-7.354-18.493,1.98-18.493,1.98v2.39l7.504-0.02l-3.084,2.943v4.136
				l13.876-5.164v7.078c0,0-2.949-2.016-6.775-1.169c-2.355,0.521-5.948,1.908-6.964,1.954c-4.622,0.206-4.928-3.055-4.982-4.717
				c-0.039-1.184,1.314-1.007,1.314-1.007v-2.037h-6.025c0,0-0.308,1.902-0.104,3.587c0.515,4.994,3.376,6.96,5.849,7.502
				c4.772,1.044,8.046-1.93,11.22-2.209c3.833-0.345,6.439,2.326,6.439,2.326v1.178h5.236V19.73c0.297-0.887,1.074-1.246,1.36-1.294
				c2.265-0.412,3.201,0.187,3.201,0.187s-0.674,0.347-1.633,1.06c-0.928,0.671-0.583,2.072-0.516,3.197
				c0.071,1.129,2.049,1.923,2.049,1.923l1.68-0.823c-1.535-0.508-0.614-1.469-0.614-1.469s5.933-2.766,6.958-3.21
				c0,0,0.173-0.086,0.549-0.214c0.375-0.128,0.813-0.072,1.052,0.43C96.732,20.019,97.096,20.917,96.613,21.229z M69.661,23.65
				c0,0-0.395,0.248-0.607,0.015c-0.101-0.1-0.037-0.288,0.194-0.51l1.201-1.103c0,0,1.053-0.984-0.415-1.056
				c-1.476-0.067-3.697-0.062-3.697-0.062s-0.694,0.086-0.744-0.23c-0.029-0.149-0.026-0.333,0.229-0.492
				c0.585-0.381,9.387-2.394,11.819,0.578L69.661,23.65z M125.646,26.219c0,0,0.408-1.485-2.498-2.747
				c-0.383-0.168-2.958-1.349-5.473-2.38c-0.412-0.162-0.622-0.922,0.132-1.195c0.755-0.272,4.77-1.398,4.77-1.398h3.503
				c0,0,2.479,0.011,2.479,2.436l0.011,9.701c0,0-1.923-1.962-5.971-3.155L125.646,26.219z"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#221F1F"
          d="M224.668,16.678h-39.38H147.02v1.983l5.483-0.002c-5.901,1.801-5.292,4.745-5.292,4.745v5.163
			c0.143,2.581,3.103,2.291,3.103,2.291s3.027-0.484,4.768-1.195c2.116-0.665,3.105-1.352,3.105-1.352
			c2.242-1.037,1.433-2.85,1.372-3.017c-0.488-1.201-2.364-2.756-2.364-2.756l-2.131,0.665l0.467,0.461
			c0.789,0.577-0.67,1.367-0.67,1.367l-3.404,1.077c-1.76,0.416-1.164-0.848-1.075-1.021c0.479-1.081,2.6-2.102,3.339-2.488
			c5.405-2.86,6.734-0.5,7.354,0.166c4.07,4.348,0.171,7.735-0.679,8.494c-2.548,2.286-6.194,4.39-10.977,4.445
			c-5.304,0.062-6.536-2.496-6.536-2.496l0.494-1.18l-1.906-0.982l-4.369,5.202c16.198,11.053,27.709-3.333,27.709-3.333
			c2.552,0.866,3.983,2.611,3.983,2.611v1.682h5.093V21.387c-0.037-2.342-1.586-2.728-1.586-2.728h3.452
			c1.829,0.673,1.616,2.756,1.616,2.756V37.21h5.291V21.184c-0.022-2.281-1.686-2.525-1.686-2.525h4.089h7.421
			c-0.973,0.646-1.986,1.421-4.508,3.324c-2.515,2.118-2.114,4.554-2.114,4.554v5.016c-0.067,0.911,0.85,2.097,1.292,2.444
			c3.372,2.652,6.158,3.692,7.515,4.09c3.94,1.156,5.96-1.174,5.96-1.174l1.821-1.958l-1.872-1.011
			c-1.335,2.114-4.685-0.163-4.685-0.163s-2.102-1.244-3.002-1.784c-2.599-1.662-2.55-2.397-2.55-2.397l0.024-5.728
			c0.243-1.726,6.17-5.211,6.17-5.211h17.136c2.008,0.66,1.791,2.875,1.791,2.875v3.427c-2.524-1.949-4.456-0.787-4.456-0.787
			l-3.166,1.579c0,0,0.799-1.136,1.763-2.495c0.904-1.284-0.351-1.691-3.07-2.944c-3.505-1.617-5.683,0.075-5.683,0.075
			s-2.175,1.163-4.436,2.819c-2.26,1.66-2.061,3.271-2.061,3.271v2.493c1.254,2.12,4.201,1.473,4.201,1.473l0.722-1.427
			c-1.85-0.111-1.5-0.939-1.24-1.254c0,0,7.082-4.32,8.379-4.994c0.192-0.101,0.627,0.058,0.456,0.434
			c-0.672,1.456-3.595,4.907-3.794,5.406c-1.225,3.15,0.9,3.99,0.9,3.99l8.718-4.307c2.261-1.083,2.766,0.56,2.766,0.56v8.578h5.082
			V21.534c0.024-2.249-1.777-2.875-1.777-2.875h3.421c2.005,0.834,1.814,2.887,1.814,2.887v15.886H229c0,0,0-13.943,0-15.901
			C229,19.574,228.024,16.678,224.668,16.678z M168.793,30.928c0,0-0.912-1.369-2.431-2.156c0,0,0.734-7.21-7.049-10.112h7.92
			c0,0,1.534,0.386,1.559,2.744V30.928z"
        />
      </g>
      <polygon
        points="38.504,69.799 20.954,70.921 20.954,49.125 30.811,49.364 32.173,56.336 37.702,56.336 37.702,36.222 
		32.173,36.222 30.731,42.793 20.954,43.034 20.954,22.199 36.741,23 39.545,31.094 45.876,31.094 44.834,16.911 1,16.911 1,22.52 
		7.251,23.642 7.251,70.359 1.08,71.162 1.08,76.45 48.28,76.45 50.204,61.386 43.392,59.461 	"
      />
      <g>
        <path
          d="M56.592,47.374L53.15,46.8v-3.089h11.077L76.406,62.51l2.471,5.296V47.374l-3.75-0.574v-3.089h11.297V46.8l-3.354,0.574
			v29.124h-6.487L63.653,56.331l-2.912-5.824V73.1l4.677,0.485v2.913H53.15v-2.913l3.442-0.485V47.374z"
        />
        <path
          d="M95.601,74.822c-2.354-1.442-4.133-3.413-5.34-5.914c-1.206-2.5-1.809-5.339-1.809-8.516c0-3.648,0.691-6.752,2.074-9.311
			c1.383-2.56,3.361-4.494,5.936-5.803c2.574-1.309,5.626-1.963,9.156-1.963c2.03,0,4.045,0.148,6.046,0.441
			c2,0.294,3.692,0.602,5.075,0.927l-0.529,8.516h-5.296l-1.235-5.824c-0.265-0.294-0.744-0.553-1.434-0.772
			c-0.691-0.221-1.626-0.331-2.802-0.331c-2.618,0-4.649,1.155-6.09,3.464c-1.442,2.311-2.162,5.657-2.162,10.039
			c0,4.355,0.61,7.804,1.831,10.348c1.22,2.545,3.125,3.818,5.714,3.818c1.059,0,2.022-0.139,2.891-0.42
			c0.867-0.279,1.522-0.64,1.963-1.081v-9.223l-4.104-0.441v-3.221h13.768v3.221l-2.206,0.353v11.606
			c-0.501,0.03-1.662,0.264-3.486,0.705c-1.795,0.471-3.413,0.846-4.854,1.125c-1.442,0.28-2.987,0.42-4.633,0.42
			C100.779,76.984,97.954,76.264,95.601,74.822z"
        />
        <path
          d="M125.035,47.419l-3.31-0.618v-3.089h15.047V46.8l-4.192,0.618v25.638l8.296-0.441l2.869-8.737l4.148,0.53l-1.279,12.091
			h-24.976v-2.913l3.398-0.441V47.419z"
        />
        <path
          d="M153.761,47.419l-3.618-0.618v-3.089h14.871V46.8l-3.707,0.618v25.726l3.707,0.485v2.869h-14.827v-2.913l3.574-0.485
			V47.419z"
        />
        <path
          d="M175.582,76.587c-1.368-0.266-2.802-0.618-4.302-1.059c-0.971-0.294-1.676-0.456-2.118-0.485l0.397-8.252h4.104
			l1.104,5.649c0.323,0.382,0.919,0.722,1.786,1.015c0.868,0.294,1.904,0.441,3.111,0.441c1.794,0,3.139-0.398,4.038-1.192
			c0.897-0.794,1.345-1.882,1.345-3.266c0-0.971-0.287-1.816-0.86-2.537c-0.574-0.72-1.368-1.383-2.383-1.986
			c-1.015-0.602-2.405-1.301-4.171-2.096c-2.324-1.058-4.287-2.405-5.89-4.037c-1.604-1.633-2.406-3.787-2.406-6.465
			c0-1.647,0.426-3.148,1.279-4.501c0.853-1.353,2.147-2.442,3.884-3.266c1.735-0.823,3.899-1.235,6.487-1.235
			c1.56,0,2.92,0.103,4.082,0.308c1.161,0.207,2.405,0.485,3.728,0.838c0.707,0.236,1.25,0.369,1.633,0.397l-0.266,7.855h-4.015
			l-1.015-5.427c-0.207-0.264-0.669-0.507-1.389-0.728c-0.722-0.22-1.523-0.331-2.406-0.331c-1.617,0-2.831,0.384-3.64,1.148
			c-0.81,0.764-1.214,1.75-1.214,2.956c0,1.059,0.338,1.986,1.015,2.78c0.676,0.795,1.493,1.464,2.449,2.009
			c0.955,0.544,2.419,1.301,4.391,2.272c1.558,0.766,2.92,1.538,4.082,2.317c1.161,0.779,2.154,1.786,2.979,3.023
			c0.823,1.235,1.235,2.677,1.235,4.324c0,1.619-0.39,3.178-1.169,4.678c-0.779,1.501-2.111,2.752-3.994,3.751
			c-1.883,1-4.355,1.501-7.414,1.501C178.442,76.984,176.95,76.851,175.582,76.587z"
        />
        <path
          d="M198.595,47.374l-3.177-0.574v-3.089h14.297V46.8l-3.618,0.574v10.546h12.091V47.419l-3.31-0.618v-3.089H229V46.8
			l-3.266,0.574v25.77L229,73.586v2.913h-14.122v-2.913l3.31-0.485V61.672h-12.091v11.473l3.618,0.441v2.913h-14.386v-2.913
			l3.266-0.441V47.374z"
        />
      </g>
    </g>
  </svg>
);

EnglishHeaderLogo.propTypes = {
  width: string,
  height: string
};

export default EnglishHeaderLogo;
